import { lazy } from "react";

const SendInivatation = lazy(() => import("../Component/CommonFunctionality/SendInivatation"));

const commonRoutes = [
  { path: "/Invitation-by-sales-person", element: <SendInivatation />, protected: false },
];

export default commonRoutes;
